<template>
  <div class="index">
  <v-header></v-header>


    <div style="padding-top: 60px;">

    <swipe class="my-swipe my-swipeone" :speed="500" :auto="5000">
         <swipe-item class="slide1">
         <div class="p1one">
            <p  class="p1">因为专注 所以卓越</p>
            <p class="p2">凡高智慧校园云平台</p>
            <p class="p3">智慧校园教育信息化产品打造者</p>
         </div>
          <img src="../../static/img/sybanner-1.png">
        </swipe-item>
         <swipe-item class="slide2">
         <div class="p1one">
            <p  class="p1">持续专注于教育信息化</p>
            <p class="p2">云校园整体解决方案</p>
            <p class="p3">服务/创新/专业/诚信</p>
         </div>
          <img src="../../static/img/sybanner-2.png">
        </swipe-item>
       
        <swipe-item class="slide3">
          <div class="p1one">
            <p  class="p1">智慧校园软硬件一体解决方案</p>
            <p class="p2">电子班牌+闸机+人脸识别+高清人脸抓拍视频监控</p>
            <p class="p3">设备全联接，系统全联动，业务全智能</p>
         </div>
          <img src="../../static/img/sybanner-3.png">
        </swipe-item>
    </swipe>

      <div   class="product">
        <h2   class="item-title">
          <span   class="eg">垂直校园产品，深度信息化解决方案</span> 
          <span   class="ch">
                                为客户提供Fintech、SaaS、AI、IOT及大数据等服务，打造一体化智能校园解决方案
          </span>
        </h2>
        <div   class="item-pro">
          <dl  style=" margin-bottom: 60px;">
            <!-- <router-link to="/classselection"> -->

            <dt  >
              <img src="../../static/img/c-icon-1.png">
            </dt>
            <dd  >
              <span class="notetitle" >综合管理平台</span>
              <span   class="note">一站式掌握教职工管理，学生管理，家校互联，教务办公等核心业务管理</span>
            </dd>
            <!-- </router-link> -->

          </dl>
          <dl  style=" margin-bottom: 60px;">
            <!-- <router-link to="/classcard"> -->

            <dt  >
              <img src="../../static/img/c-icon-2.png">
            </dt>
            <dd  >
              <span  class="notetitle">招生缴费系统</span>
              <span   class="note">覆盖全部场景，自定义模板，凡高教育助力中学招生，缴费不再繁琐</span>
            </dd>
            <!-- </router-link> -->

          </dl>
          <dl  >
            <!-- <router-link to="/campuspaymen"> -->

            <dt  >
              <img src="../../static/img/c-icon-3.png">
            </dt>
            <dd  >
              <span   class="notetitle">校园一脸通</span>
              <span   class="note">学生刷脸支付，无卡无忧，校园消费场景全覆盖，消费信息随时在线查询</span>
            </dd>
            <!-- </router-link> -->

          </dl>
          <dl  >
            <!-- <router-link to="/homeschool"> -->

            <dt  >
              <img src="../../static/img/c-icon-4.png">
            </dt>
            <dd  >
              <span   class="notetitle">智慧校园Alot硬件</span>
              <span   class="note">实现校园万物互联，打破各系统数据孤岛，打造“全数字、全链接、全融合”的智慧校园</span>
            </dd>
            <!-- </router-link> -->

          </dl>
        </div>
      </div>

      <div   class="service">
        <h2   class="item-title"><span   class="eg">我们的特色</span> <span   class="ch">致力于人工智能推动未来教育与教务管理</span></h2>
        <div   class="item-pro">
          <dl   style="display: flex; justify-content: space-around;">
            <dt  >
              <img src="../../static/img/s-icon-1.png">
            </dt>
            <dd  >
              <span  class="sertitleone">校园系统全联动</span>
              <span class="sertitletwo"  >传统方式下校园子系统烟囱式分散独立，难以实现业务联动控制和集中管理，基于凡高智慧校园平台实现数据聚合，通过简单灵活的规则配置，实现跨系统全联动。</span>
            </dd>
          </dl>
          <dl   style="display: flex; justify-content: space-around;">
            <dt  >
              <img src="../../static/img/s-icon-2.png">
            </dt>
            <dd  >
              <span   class="sertitleone">校园业务全智能</span>
              <span  class="sertitletwo">平台集中管理校园各子系统，提供各类标准化北向API接口，支撑上层业务应用快速创新，为校园各业务智能应用。</span>
            </dd>
          </dl>
          <dl   style="display: flex; justify-content: space-around;">
            <dt  >
              <img src="../../static/img/s-icon-3.png">
            </dt>
            <dd  >
              <span    class="sertitleone">校园设备全联接</span>
              <span class="sertitletwo" >物联网平台支持任意设备通过多种网络和多种协议接入，实现园区物联网终端设备的快速联接；同时对接各个系统，实现园区设备全联接，数据统一汇聚。</span>
            </dd>
          </dl>
      
        </div>
      </div>

       <div   class="solution">
          <h2   class="item-title"><span   class="eg">优秀学校案例</span> <span   class="ch">致力于帮助客户解决实际业务场景问题</span></h2>
          <swipe class="my-swipetwo" :speed="500" :auto="5000">
              <swipe-item class="slide1">
                  <div   class="item-pro" >
                      <dl  >
                        <dt  >
                          <img src="../../static/img/yx-erzhong.png">
                        </dt>
                        <dd  >
                          <span   class="titlies">河北衡水市第二中学</span>
                          <span   class="note">凡高教育系统为我校的招生，缴费，一卡通，管理，教务，财务，校园安全等工作提供了统一正规高效的流程提高了学校的管理水平与效率！实现集团校业务标准化、数字化管理。</span>
                        </dd>
                      </dl>
                    </div>
              </swipe-item>
              <swipe-item class="slide1">
                  

                    <div   class="item-pro" >
                      <dl  >
                        <dt  >
                          <img src="../../static/img/yx-shi.png">
                        </dt>
                        <dd  >
                          <span   class="titlies">石家庄精英中学</span>
                          <span   class="note">以前开学收费比较慢，家长要在财务处排半天队；老师们收费、记账，工作繁重。现在，幼儿园将收费二维码分享给家长，家长用微信扫一扫，随时随地就能缴费，免去请假排队、浪费时间。老师在学加家后台实时查看收费状况，一键导出财务报表，效率大幅提升。</span>
                        </dd>
                      </dl>
                    </div>
              </swipe-item>
            
              <swipe-item class="slide3">
                  <div   class="item-pro" >
                    <dl  >
                      <dt  >
                        <img src="../../static/img/yx-wuzhong.png">
                      </dt>
                      <dd  >
                        <span   class="titlies">河北衡水市第五中学</span>
                        <span   class="note">学生招生是一个很繁杂的工作，学生的报名信息很多，使用了凡高的招生缴费系统之后学生信息更明晰，线上一键审核，招生审核效率更高，还有线上缴费非常快捷。</span>
                      </dd>
                    </dl>
                  </div> 
              </swipe-item>
          </swipe>
           
      </div>


      <div   class="productfooter">
        <h2   class="item-title">
          <span   class="eg">合作伙伴</span> 
          
        </h2>
        <div   class="item-pro">
          <dl >
            <dt  >
              <img src="../../static/img/school-1.png">
            </dt>
            <dd  >
              <span   class="note">衡水市第二中学</span>
            </dd>
          </dl>
          <dl >
            <dt  >
              <img src="../../static/img/school-2.png">
            </dt>
            <dd  >
              <span   class="note">支付宝</span>
            </dd>
          </dl>
          <dl  >
            <dt  >
              <img src="../../static/img/school-3.png">
            </dt>
            <dd  >
              <span   class="note">石家庄精英中学</span>
            </dd>
          </dl>
          <dl  >
            <dt  >
              <img src="../../static/img/school-4.png">
            </dt>
            <dd  >
             
              <span   class="note">衡水第五中学</span>
            </dd>
           
          </dl>
          <dl >
            <dt  >
              <img src="../../static/img/school-5.png">
            </dt>
            <dd  >
              <span   class="note">武邑中学</span>
            </dd>
          </dl>
          <dl >
            <dt  >
              <img src="../../static/img/school-6.png">
            </dt>
            <dd  >
              <span   class="note">光大银行</span>
            </dd>
          </dl>
          <dl  >
            <dt  >
              <img src="../../static/img/school-7.png">
            </dt>
            <dd  >
              <span   class="note">衡水市第十三中学</span>
            </dd>
          </dl>
          <dl  >
            <dt  >
              <img src="../../static/img/school-8.png">
            </dt>
            <dd  >
             
              <span   class="note">衡水银行</span>
            </dd>
           
          </dl>
          <dl >
            <dt  >
              <img src="../../static/img/school-9.png">
            </dt>
            <dd  >
              <span   class="note">冀州中学</span>
            </dd>
          </dl>
          <dl >
            <dt  >
              <img src="../../static/img/school-10.png">
            </dt>
            <dd  >
              <span   class="note">志臻实验中学</span>
            </dd>
          </dl>
          <dl  >
            <dt  >
              <img src="../../static/img/school-11.png">
            </dt>
            <dd  >
              <span   class="note">南宫中学</span>
            </dd>
          </dl>
          <dl  >
            <dt  >
              <img src="../../static/img/school-12.png">
            </dt>
            <dd  >
             
              <span   class="note">苍龙国际学校</span>
            </dd>
           
          </dl>
        </div>
      </div>

      </div>



  <v-footer></v-footer>
  </div>
</template>

<script>
  import Vue from 'vue'
  import header from './header.vue'
  import footer from './footer.vue'
  export default {
    name: 'HelloWorld',
    data () {
    return {

    }
  },
  components :{
    'v-header':header,
    'v-footer':footer,
  },
  methods: {

  }

  }
</script>
<style lang="">
  .my-swipetwo .mint-swipe-indicators{
    display: none !important;
    border-radius: 0 !important;
  }
.my-swipetwo .mint-swipe-indicator{
    display: none !important;
    border-radius: 0 !important;
  }

</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  @import 'vue-swipe/dist/vue-swipe.css';
  .banner-textone{
  margin-left: 10%;
   text-align: left;
}
.banner-textone p{
  font-family:'PingFangSC-Medium';
  font-size:20px;
  letter-spacing: 1px;
  color: #4c9bbc;
  margin-bottom: 10px;
  margin-top: 30px;
}
.banner-textone .english{
  width: 82px;
	height: 2px;
  background-color: #5da6c5;
  margin-top: 0px;
  margin-bottom: 5px;
}

.banner-textone span{
  display: block;
   font-family: 'PingFangSC-Regular';
  font-size: 11px;
  color: #4c9bbc;
  line-height: 11px;
  letter-spacing: 1px;
  font-weight: bold;
  margin-top: 13px;
}
  .my-swipeone img{
    width: 100%;
    height:600px;
  }
  .my-swipeone {
     height:600px;
    
    text-align: center;
    overflow: hidden;
  }


   .slide1 .p1one {
     position: absolute;
    top: 27%;
    left: 0;
    bottom: 0;
    right: 0;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    -ms-flex-align: center;
    -ms-flex-direction: column;
    flex-direction: column;
   
  }
  .slide1 .p1{
    top: 20%;
 font-size:30px;
font-family:PingFang SC;
font-weight:400;
color:rgba(254,255,255,1);
  }
  .slide1 .p2{
font-size:40px;
font-family:PingFang SC;
font-weight:bold;
color:rgba(254,255,255,1);
/* margin: 30px auto; */
margin-top: 30px;
margin-bottom: 26px;
  }
  .slide1 .p3{
font-size:20px;
font-family:PingFang SC;
font-weight:400;
color:rgba(254,255,255,1);
  }
  .slide2 .p1one {
     position: absolute;
    top: 28%;
    left: 0;
    bottom: 0;
    right: 0;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    -ms-flex-align: center;
    -ms-flex-direction: column;
    flex-direction: column;
    
   
  }
  .slide2 .p1{
    /* top: 20%; */
 font-size:40px;
font-family:PingFang SC;
font-weight:bold;
color:rgba(254,255,255,1);
  }
  .slide2 .p2{
font-size:40px;
font-family:PingFang SC;
font-weight:bold;
color:rgba(254,255,255,1);
margin: 10px auto;
  }
  .slide2 .p3{
    margin: 10px auto;
    width: 270px;
    height: 40px;
    line-height: 40px;
font-size:23px;
font-family:PingFang SC;
font-weight:400;
color:rgba(254,255,255,1);
background:rgba(255,255,255,0.3);
  border-radius:20px;
  }
   .slide3 .p1one {
     position: absolute;
    top: 30%;
    left: 0;
    bottom: 0;
    right: 0;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    -ms-flex-align: center;
    -ms-flex-direction: column;
    flex-direction: column;
    width: 550px;
    margin: 0 auto;
    text-align: left;
   
  }
  .slide3 .p1{
    /* top: 20%; */
    font-size:40px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(254,255,255,1);
  }
  .slide3 .p2{
    font-size:23px;
    font-family:PingFang SC;
    /* font-weight:bold; */
    color:rgba(254,255,255,1);
    margin: 10px 0;
  }
  .slide3 .p3{
    font-size:23px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(254,255,255,1);
  }
  .item-title {
    text-align: center;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-direction: column;
    flex-direction: column;
    /* margin-top: 100px; */
  }
  .item-title .eg {
    margin-bottom: 20px;
    font-size:36px;
font-family:PingFang SC;
font-weight:bold;
color:rgba(0,0,0,1);
  }
  .item-title .ch {
    /* margin-bottom: 80px; */
    width:508px;
    height:60px;
    font-size:24px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(0,0,0,1);
/* line-height:36px; */
  }
  .carouse  {
    position: relative
  }

  .carouse img  {
    width: 100%
  }

  .carouse .pagination-box  {
    position: absolute;
    bottom: 35px;
    left: 0;
    right: 0;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center;
    -ms-flex-align: center;
    align-items: center
  }

  .carouse  .swiper-pagination {
    position: static;
    padding: 0 5px;
    border-radius: 15px;
    background: hsla(0,0%,78%,.3)
  }

  .carouse  .swiper-pagination /deep/ .swiper-pagination-bullet {
    background: transparent;
    border: 1px solid #fff;
    box-sizing: border-box;
    margin: 0 3px
  }

  .carouse  .swiper-pagination /deep/ .swiper-pagination-bullet.swiper-pagination-bullet-active {
    background: #fff
  }

  .carouse .note  {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-direction: column;
    flex-direction: column;
    color: #fff;
    font-size: 28px
  }

  .carouse .note>span  {
    line-height: 42px
  }
.product{
  padding: 100px 0;
}
  .product .item-pro  {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: distribute;
    justify-content: space-around;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin-top: 80px;
    /* margin-bottom: 50px; */
  }

  .product .item-pro dl  {
    width: 45%;
    padding: 0 15px;
   
    box-sizing: border-box
  }

  .product .item-pro dl img  {
    /* height: 79px */
    width: 160px;
    height: 142px;
  }

  .product .item-pro dd ,.product .item-pro dt  {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center
  }

  .product .item-pro dd  {
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-direction: column;
    flex-direction: column
  }

  .product .item-pro dd .note  {
   
    margin-top: 5px;
    text-align: center;
    font-size:24px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(0,0,0,1);
    line-height:36px;
  }
.product .item-pro dd .notetitle{
font-size:30px;
font-family:PingFang SC;
font-weight:400;
color:rgba(0,0,0,1);
/* line-height:21px; */
margin: 20px 0;
}


.productfooter{
 background-image: url('~@/../static/img/s-footer-bg.png');
    background-size: 100% 100%;
padding: 100px 0;
}
  .productfooter .item-pro  {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: distribute;
    justify-content: space-around;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin-top: 40px;
    /* margin-bottom: 50px; */
    width: 89%;
    margin: 0 auto;
  }
  .productfooter .item-pro dl  {
    width: 30%;
    padding: 0 15px;
    box-sizing: border-box;
    margin-top: 46px;
  }
  .productfooter .item-pro dl img  {
    /* height: 79px */
    width: 100px;
    height: 100px;
  }

  .productfooter .item-pro dd ,.productfooter .item-pro dt  {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center
  }

  .productfooter .item-pro dd  {
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-direction: column;
    flex-direction: column
  }

  .productfooter .item-pro dd .note  {
   
    margin-top: 10px;
    text-align: center;
    font-size:20px;
font-family:PingFang SC;
font-weight:400;
color:rgba(33,33,33,1);
line-height:27px;
  }
  .solution  {
   padding: 100px 0;
  }

  .solution .item-pro  {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: distribute;
    justify-content: space-around;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    /* margin-top: 80px; */
   margin: 60px  auto 0 auto;
    width:702px;
    height:580px;
    background:rgba(255,255,255,1);
    border-radius:20px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, .2);
  padding-bottom: 20px;
  }
.solution .my-swipetwo{
    height:690px;
    
}

  .solution .item-pro dl  {
    width: 100%;
    padding: 0 15px;
    box-sizing: border-box;
    /* height:580px; */
  }

  .solution .item-pro dl img  {
   width:200px;
  height:200px;
  margin-top: 60px;
  margin-bottom: 10px;
  }

  .solution .item-pro dd ,.solution .item-pro dt  {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center
  }

  .solution .item-pro dd  {
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-direction: column;
    flex-direction: column;
text-align: center;
    font-size:30px;
font-family:PingFang SC;
font-weight:400;
color:rgba(0,0,0,1);
line-height:21px;


  }
.solution .item-pro dd .titlies{
font-size:30px;
font-family:PingFang SC;
font-weight:400;
color:rgba(0,0,0,1);
line-height:21px;
margin: 30px 0;
}
  .solution .item-pro dd .note  {
    margin-top: 5px;
    text-align: center;
    letter-spacing: .5px;
width:602px;
    font-size:24px;
font-family:PingFang SC;
font-weight:400;
color:rgba(0,0,0,1);
line-height:32px;
/* margin-bottom: 10px; */
  }

  .service  {
    padding: 100px 0;
    background-image: url('~@/../static/img/s-icon-bg.png');
    background-size: 100% 100%;
  }

  .service .item-pro  {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-direction: column;
    flex-direction: column
  }

  .service dl  {
    display: -ms-flexbox;
    display: flex;
    margin-top: 30px
  }

  .service dl dt  {
    -ms-flex-negative: 0;
    flex-shrink: 0;
    margin: 0 15px 0 20px
  }

  .service dl dt img  {
    height: 120px;
    width: 120px
  }
.sertitleone{
font-size:30px;
font-family:PingFang SC;
font-weight:400;
color:rgba(0,0,0,1);
line-height:21px;
margin-top: 30px;
}
.sertitletwo{
font-size:24px;
font-family:PingFang SC;
font-weight:400;
color:rgba(14,5,10,1);
line-height:36px;
margin-top: 30px; letter-spacing: 0.5px;
}
  .service dl dd  {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-direction: column;
    flex-direction: column;
    padding-right: 30px;
    -ms-flex: 1;
    flex: 1
  }

  .partner  {
   padding: 100px 0;
    background: #f4f4f4
  }

  .partner .pics  {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: distribute;
    justify-content: space-around;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    padding: 0 5px;
    margin-top: 40px
  }
.partner .pics  dl  {
    width: 25%;
    box-sizing: border-box;
    margin: 15px 0;
  }

  .partner .pics  dl img  {
    height:52px;
    width: 52px;
    padding: 0 15px;
  }

  .partner .pics dd ,.pics dt  {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center
  }

  .partner .pics dd  {
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-direction: column;
    flex-direction: column;
     /* width: 100px; */
    height: 11px;
    font-family: SourceHanSansCN-Regular;
    font-size: 11px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 11px;
    letter-spacing: 0px;
    color: #212121;
  }
  
.notesone {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    -ms-flex-align: center;
    
    -ms-flex-direction: column;
    flex-direction: column;
    color: #fff;
    font-size: 28px;
  }

  
</style>



// WEBPACK FOOTER //
// src/components/indexs.vue